import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepClaimSummary = (state) => state.get('stepClaimSummary');

const makeSelectStepClaimSummary = () =>
  createSelector(selectStepClaimSummary, (stepClaimSummaryState) => ({
    givePermission: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'givePermission']),
      ''
    ),

    validated: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'validated']),
      true
    ),

    thirdPartyTitle: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'thirdPartyTitle']),
      ''
    ),
    thirdPartyFirstName: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'thirdPartyFirstName']),
      ''
    ),
    thirdPartySurName: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'thirdPartySurName']),
      ''
    ),
    thirdPartyDateOfBirth: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'thirdPartyDateOfBirth']),
      ''
    ),
    thirdPartyRelationShip: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'thirdPartyRelationShip']),
      ''
    ),
    thirdPartyAddressLine1: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'thirdPartyAddressLine1']),
      ''
    ),
    thirdPartyAddressLine2: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'thirdPartyAddressLine2']),
      ''
    ),
    thirdPartyCity: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'thirdPartyCity']),
      ''
    ),
    thirdPartyCountry: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'thirdPartyCountry']),
      ''
    ),
    thirdPartyState: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'thirdPartyState']),
      ''
    ),
    thirdPartyPostal: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'thirdPartyPostal']),
      ''
    ),
    thirdPartyMobilePhone: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'thirdPartyMobilePhone']),
      ''
    ),
    thirdPartyHomePhone: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'thirdPartyHomePhone']),
      ''
    ),
    thirdPartyWorkPhone: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'thirdPartyWorkPhone']),
      ''
    ),
    thirdPartyEmail: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'thirdPartyEmail']),
      ''
    ),
    preferredContactEmailForClaim: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'preferredContactEmailForClaim']),
      ''
    ),
    preferredContactNumberForClaim: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'preferredContactNumberForClaim']),
      ''
    ),
    preferredContactForClaim: mapWithDefault(
      stepClaimSummaryState,
      () => stepClaimSummaryState.getIn(['form', 'preferredContactForClaim']),
      ''
    ),
  }));

const makeSelectStepClaimSummaryDirty = () =>
  createSelector(selectStepClaimSummary, (state) => state.get('dirty'));

const makeSelectStepClaimSummaryInvalidContactEmail = () =>
  createSelector(selectStepClaimSummary, (state) => state.get('invalidContactEmail'));

const makeSelectExchangeRates = () =>
  createSelector(selectStepClaimSummary, (state) => {
    const rates = state.get('exchangeRates');
    return rates && typeof rates.toJS === 'function' ? rates.toJS() : (rates || {});
  });

const makeSelectExchangeRatesLoading = () =>
  createSelector(selectStepClaimSummary, (state) => state.get('exchangeRatesLoading'));

export { makeSelectStepClaimSummary, makeSelectStepClaimSummaryDirty, makeSelectStepClaimSummaryInvalidContactEmail, makeSelectExchangeRates, makeSelectExchangeRatesLoading };



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepClaimSummary/selectors.js